export const getFilenameFromDisposition = (headerValue, fallback) => {
  const value = String(headerValue || "");
  const encodedMatch = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(value);
  if (encodedMatch?.[1]) {
    try {
      return decodeURIComponent(encodedMatch[1]);
    } catch (_) {
      // Fall through to the basic filename parser below.
    }
  }

  const match = /filename="?([^";]+)"?/i.exec(value);
  return match?.[1] || fallback;
};

export const slugifyLabel = (value, fallback = "file") =>
  String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase() || fallback;

export const extractBlobErrorMessage = async (error) => {
  const data = error?.response?.data;
  if (!(data instanceof Blob)) return null;

  try {
    const text = await data.text();
    if (!text) return null;
    const parsed = JSON.parse(text);
    if (typeof parsed?.detail === "string" && parsed.detail.trim()) {
      return parsed.detail;
    }
  } catch (_) {
    return null;
  }

  return null;
};

export const downloadBlobFile = (blobData, filename, mimeType) => {
  const blobUrl = window.URL.createObjectURL(
    new Blob([blobData], mimeType ? { type: mimeType } : undefined)
  );
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};
